import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Tag,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { MdSettings } from "react-icons/md";
import { useHistory, useParams } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { TierForm } from "../../forms";
import { ICreateTierValues } from "../../forms/TierForm";
import {
  HealthInsuranceCardType,
  TierDocument,
  TiersDocument,
  useDeleteTierMutation,
  usePublishTierMutation,
  useTierQuery,
  useUpdateTierMutation,
} from "../../graphql";
import { useDashboardTitle } from "../../hooks/useDashboardTitle";

const TierPage: React.FC = () => {
  const { setTitle } = useDashboardTitle();
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useTierQuery({
    variables: {
      id: parseInt(id),
    },
  });
  const tier = data?.tier;

  const [updateTier] = useUpdateTierMutation();
  const [deleteTier] = useDeleteTierMutation();
  const [publishTier] = usePublishTierMutation();

  const handleUpdateTierEvent = async (tier: ICreateTierValues) => {
    await updateTier({
      variables: {
        id: data?.tier?.id,
        activeDays: parseInt(tier.activeDays),
        color: tier.color,
        default: tier.default === "1",
        descriptionEn: tier.description.en,
        descriptionSq: tier.description.sq,
        descriptionMk: tier.description.mk,
        nameEn: tier.name.en,
        nameSq: tier.name.sq,
        nameMk: tier.name.mk,
        eventsPerMonth: parseInt(tier.eventsPerMonth),
        pricePerYear: parseFloat(tier.pricePerYear),
        demo: tier.demo === "1",
        benefitIDs: tier.benefitIDs,
        sigalHealthInsuranceType: tier.sigalHealthInsuranceType
          ? tier.sigalHealthInsuranceType
          : null,
      },
      refetchQueries: [
        {
          query: TierDocument,
          variables: {
            id: parseInt(id),
          },
        },
        {
          query: TiersDocument,
        },
      ],
    });

    // newTier.createTier.id
    // onClose();
  };

  const handleTierDelete = async () => {
    await deleteTier({
      variables: {
        id: tier.id,
      },
      refetchQueries: [
        {
          query: TiersDocument,
        },
      ],
    });

    history.push("/tiers");
  };

  const handleTierPublic = () => {
    publishTier({
      variables: {
        id: tier.id,
      },
      refetchQueries: [
        {
          query: TiersDocument,
        },
      ],
    });
  };

  useEffect(() => {
    if (!loading) {
      setTitle([
        {
          to: "/tiers",
          text: "Paketa",
        },
        tier.name,
      ]);
    }

    // eslint-disable-next-line
  }, [loading]);

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Shto detaj</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <TierDetailForm onSubmit={(tier) => handleDetailCreate(tier)} /> */}
          </ModalBody>
        </ModalContent>
      </Modal>
      <>
        <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
          <Title title="Paketa">
            <Box m={[0, 0, 2]}>
              {!loading && tier?.isPublic ? (
                <Tag borderRadius="full" variant="solid" colorScheme="green">
                  publike
                </Tag>
              ) : (
                <Tag borderRadius="full" variant="solid" colorScheme="red">
                  e pa publikuar
                </Tag>
              )}
            </Box>
            <Box m={[0, 0, 2]}>
              {tier?.isDefaultForSigalClients ? (
                <Tag borderRadius="full" variant="solid" colorScheme="blue">
                  e parazgjedhur
                </Tag>
              ) : (
                ""
              )}
              {tier?.isDefaultForDemo ? (
                <Tag borderRadius="full" variant="solid" colorScheme="blue">
                  demo
                </Tag>
              ) : (
                ""
              )}
              {tier?.sigalHealthInsuranceType ===
              HealthInsuranceCardType.Silver ? (
                <Tag borderRadius="full" variant="solid" colorScheme="gray">
                  silver
                </Tag>
              ) : (
                ""
              )}

              {tier?.sigalHealthInsuranceType ===
              HealthInsuranceCardType.Gold ? (
                <Tag borderRadius="full" variant="solid" colorScheme="orange">
                  gold
                </Tag>
              ) : (
                ""
              )}

              {tier?.sigalHealthInsuranceType ===
              HealthInsuranceCardType.Standard ? (
                <Tag
                  borderRadius="full"
                  variant="solid"
                  colorScheme="blackAlpha"
                >
                  standard
                </Tag>
              ) : (
                ""
              )}
            </Box>
            <Menu>
              <MenuButton
                px={4}
                py={2}
                transition="all 0.2s"
                borderRadius="md"
                _focus={{ boxShadow: "outline" }}
              >
                <MdSettings />
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => handleTierPublic()}>
                  {tier?.isPublic ? "Terhiqe nga publikimi" : "Publiko"}
                </MenuItem>
                <MenuItem onClick={() => handleTierDelete()}>Fshi</MenuItem>
              </MenuList>
            </Menu>
          </Title>
          {loading ? (
            <Loader />
          ) : (
            <>
              <TierForm
                onSubmit={(tier) => handleUpdateTierEvent(tier)}
                initialValues={{
                  activeDays: `${tier.activeDays}`,
                  color: tier.color,
                  default: tier.isDefaultForSigalClients ? "1" : "0",
                  demo: tier.isDefaultForDemo ? "1" : "0",
                  description: tier.rawDescription,
                  eventsPerMonth: `${tier.eventsPerMonth}`,
                  name: tier.rawName,
                  pricePerYear: `${tier.pricePerYear}`,
                  benefitIDs: tier.benefits.map((i) => i.id),
                  sigalHealthInsuranceType: tier.sigalHealthInsuranceType,
                }}
              />

              {/* <Title title="Detaje të paketës"></Title>

              {tier.details.map((detail) => (
                <TierDetail tierId={tier.id} detail={detail} />
              ))}

              <Box
                border="1px solid lightgrey"
                w="100%"
                p={2}
                m={"5px 0"}
                justifyContent="center"
                textAlign="center"
              >
                <Button variant="link" onClick={onOpen}>
                  Shto
                </Button>
              </Box> */}
            </>
          )}
        </Box>
      </>
    </>
  );
};

export default TierPage;
